module.exports = __webpack_public_path__ + "img/cg_oldtown_bridge.60121dea.jpg";